import { render, staticRenderFns } from "./OSLogo.vue?vue&type=template&id=3731a89a&scoped=true&"
import script from "./OSLogo.vue?vue&type=script&lang=ts&"
export * from "./OSLogo.vue?vue&type=script&lang=ts&"
import style0 from "./OSLogo.vue?vue&type=style&index=0&id=3731a89a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.6_fb85a9817f99bdf862e5e3a442a1fb91/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3731a89a",
  null
  
)

export default component.exports